import React, { useContext, useState } from "react";
import clsx from "clsx";
import Chat from "../chat";
import StepperForm from "./StepperForm";
import { DAYS, MONTHS, YEARS } from "../../lists";
import { AppContext } from "../../context/appContext";


const fullNameConfig: any[] = [
  {
    tag: 'input',
    // label: 'First Name',
    name: 'firstName',
    placeholder: 'First Name',
    type: 'text',
    required: true
  },
  {
    tag: 'input',
    // label: 'Last Name',
    name: 'lastName',
    placeholder: 'Last Name',
    type: 'text',
    required: true
  },
  // {
  //   tag: 'input',
  //   label: 'Phone',
  //   name: 'phone',
  //   placeholder: 'Phone',
  //   type: 'text',
  //   required: true
  // },
];



function Stepper() {
  const [currentStep, setCurrentStep] = useState(0);
  const {widgetConfig} = useContext(AppContext);
  const steps = [
    {
      title: widgetConfig?.customText.welcomeFormTitle || 'Welcome, I’ll get you an awesome price in minutes. Ready to go?', 
      component: StepperForm, 
      config: widgetConfig.customText.welcomeFormFields.length 
        ? widgetConfig.customText.welcomeFormFields
        : fullNameConfig
    },
    {title: '', component: Chat },
  ]

  const nextStep = () => {
    setCurrentStep(currentStep + 1 < steps.length - 1 ? currentStep + 1 : steps.length - 1);
  }

  const prevStep = () => {
    setCurrentStep(currentStep-1 > 0 ? currentStep - 1 : 0 );
  }

  const onSubmit = () => {

  }

  return (
    <div className="stepper flex flex-col justify-center items-center w-full h-full">
      {
      widgetConfig.render && widgetConfig.render.chat 
        ? <div className={clsx("step w-full h-full", "step-1")}>
            <Chat />
          </div>
        : steps.map((item, key) => {
            return (
              currentStep === key &&
                <div key={key} className={clsx("step w-full h-full", "step-"+key)}>
                  <item.component
                    title={item.title} 
                    config={item.config} 
                    onSubmit={onSubmit} 
                    nextStep={nextStep} 
                    prevStep={prevStep} 
                  />
                </div>
          )
        })
      }
    </div>
  )
}

export default Stepper;
